import { observer } from 'mobx-react-lite';
import { getRuntimeEnvironment } from '@trappedmc/docker-frontend-runtime-env';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';

import { AlertDisplay } from './components/alert/AlertDisplay';
import { CookieConsent } from './components/consent/CookieConsent';
import { GlobalCartDrawer } from './views/cart/GlobalCartDrawer';

import { ErrorBoundary } from './components/error/ErrorBoundary';

import { StoreView } from './views/store/StoreView';
import { SuccessView } from './views/success/SuccessView';
import { ProductDetailsView } from './views/productdetails/ProductDetailsView';

import { ThemeConstants } from './theme/ThemeConstants';
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';

import './Application.scss';

const { REACT_APP_PUBLIC_PATH } = getRuntimeEnvironment();

export const Application = observer(() => {
  const paths = REACT_APP_PUBLIC_PATH.split(',');

  const getApplicationRoutes = ({ path }: { path: string }) => {
    return (
      <Route key={`route-${path}`} path={path}>
        <Route index element={<StoreView />} />
        <Route path='product/:handle' element={<ProductDetailsView />} />
        <Route path='success' element={<SuccessView />} />
      </Route>
    );
  };

  const ApplicationContent = () => {
    return (
      <BrowserRouter>
        <Routes>
          {paths.map((path) => getApplicationRoutes({ path }))}
          <Route path='/product/:handle' element={<ProductDetailsView />} />
          <Route path='/success' element={<SuccessView />} />
          <Route path='*' element={<StoreView />} />
        </Routes>
      </BrowserRouter>
    );
  };

  return (
    <MantineProvider defaultColorScheme='dark' theme={ThemeConstants}>
      <ErrorBoundary>
        <ApplicationContent />
        <GlobalCartDrawer />
        <AlertDisplay />
        <CookieConsent />
      </ErrorBoundary>
    </MantineProvider>
  );
});
